<!--
 * @Descripttion: 网格属性设置
 * @Author: zenghua.wang
 * @Date: 2021-04-14 11:17:44
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-12 14:58:28
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <el-collapse-item title="网格设置">
      <el-form-item label="行数">
        <el-input-number
          v-model="data.option.rows"
          :min="data.option.minRow"
          :max="data.option.maxRow"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="列数">
        <el-input-number
          v-model="data.option.cols"
          :min="data.option.minCol"
          :max="data.option.maxCol"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="格间距(px)">
        <el-input-number v-model="data.option.gap" />
      </el-form-item>

      <el-form-item label="内边距(px)">
        <el-input-number v-model="data.option.padding" />
      </el-form-item>

      <el-form-item label="圆角(px)">
        <el-input-number v-model="data.option.borderRadius" />
      </el-form-item>

      <el-form-item label="背景色">
        <el-color-picker
          v-model="data.option.backgroundColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import { component, predefineColors } from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'

export default {
  name: 'config-grid',
  components: {
    configBase,
    configAuth
  },
  props: ['data', 'collapse'],
  data() {
    return {
      component: component,
      predefineColors: predefineColors
    }
  }
}
</script>
